import React from "react";
import SelectComponent from "./SelectComponent";

// NOTE: FieldValue and dropdownData should be of same format, (Preferable, [{label:"", value:"", color_code:""}])
const RenderSelect = ({
  // activeCell,
  setActiveCell,
  dropdownData,
  cell,
  UpdateTableField,
  FieldValue,
  Item,
  type, // "dropdown" | "multiselect"
  noFormInput,
  labelKey = "label",
  valueKey = "value",
  colorKey = "color_code",
}) => {
  // Handle option click (dropdown only)
  const handleOptionClick = (value) => {
    if (type === "dropdown") {
      // SelectComponent always returns array of objects
      const selected = value?.[0];
      UpdateTableField("", noFormInput ? selected : selected?.value, Item, cell);
    }
  };

  // Handle send/confirm for multiselect
  const handleMultiSelectConfirm = (value) => {
    UpdateTableField("", noFormInput ? value : value?.map((v) => v.value), Item, cell);
  };

  return (
    <SelectComponent
      options={dropdownData}
      valueKey={valueKey}
      labelKey={labelKey}
      colorKey={colorKey}
      showSearch={true}
      value={FieldValue && (type === "multiselect" ? FieldValue : [FieldValue])}
      {...(type === "multiselect" && { multiSelect: true })}
      onChange={handleOptionClick}
      listOpen={true}
      listCloseHandler={(value) => {
        setActiveCell({ rowId: null, columnId: null });
        if (type !== "dropdown") {
          UpdateTableField("", value, Item, cell);
        }
      }}
      noFormInput={noFormInput}
      handleSendIconClick={handleMultiSelectConfirm}
      showCheckBox={type === "multiselect"}
      isCompareValue="id"
    />
  );
};

export default RenderSelect;
